import { SirenIcon, Warning } from "@phosphor-icons/react"

const ChapterAnalysisLegend = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div className="flex items-center gap-3 p-4 border border-dashed rounded-lg border-[var(--q3-stroke-light)] rounded-[16px]">
  <SirenIcon size={24} className="text-red-600" />
  <div>
    <p className="font-medium text-[var(--q3-neutral-default)]">
      This symbol indicates that you've left more than 50% of the Qs unanswered
    </p>
  </div>
</div>

<div className="flex items-center gap-3 p-4 border border-dashed rounded-lg border-[var(--q3-stroke-light)] rounded-[16px]">
  <Warning size={24} className="text-blue-600" />
  <div>
    <p className="font-medium text-[var(--q3-neutral-default)]">
      This symbol indicates that you've got more than 50% of the Qs wrong
    </p>
  </div>
</div>

    </div>
  )
}

export default ChapterAnalysisLegend